module.exports = "/build/web/svg/icon-arrow-right--white.6e686e7485cba79e76f5ef0c33cf3f59.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-arrow-right--white.svg
// module id = 123
// module chunks = 13